module.exports = __webpack_public_path__ + "static/media/no_image.0c73907c.png";